import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

/**
 * BookingSkeleton — for kirtan / katha / book-puja pages
 * Pattern: Hero → 3 service cards → booking form
 */
const BookingSkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-inner-hero" />

    <div className="conatiner">
      {/* Service cards */}
      <SkeletonBox className="sk-section-title" />
      <SkeletonBox className="sk-section-sub" />
      <div className="sk-booking-cards">
        {[1, 2, 3].map((i) => (
          <SkeletonBox key={i} className="sk-booking-card" />
        ))}
      </div>

      {/* Booking form */}
      <div className="sk-booking-form">
        <SkeletonBox className="sk-booking-form-title" />
        {[1, 2, 3, 4].map((i) => (
          <SkeletonBox key={i} className="sk-booking-field" />
        ))}
        <SkeletonBox className="sk-box" style={{ height: 52, width: 180, borderRadius: 8 }} />
      </div>
    </div>
  </div>
);

export default BookingSkeleton;
